import { render, staticRenderFns } from "./ReviewPlan.vue?vue&type=template&id=6807cd0e&"
import script from "./ReviewPlan.vue?vue&type=script&lang=js&"
export * from "./ReviewPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports